import moment from "moment";
import InfinityTable from "../../../components/infinity-table/infinity-table";
import { TableCell } from "../../../components/table/table-cell/table-cell";
import { siteScopingLabel } from "./roles-filter";

export const lastModified = (role) => {
  if (!role?.updatedAt) return "—";
  const when = `${moment(role.updatedAt).utc().format("DD MMM YYYY, HH:mm")}, UTC`;
  return role.updatedBy?.name ? `${when} · ${role.updatedBy.name}` : when;
};

// LF360-2043: the roles of the organization, in the server's order — built-in
// roles first, then custom roles by name.
const RolesTable = ({ data, onHandleRowClick, heightOffset }) => {
  const columns = [
    {
      title: "Role name",
      dataIndex: "name",
      key: "name",
      width: "24%",
      render: (_, role) => <TableCell title={role.name} />,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "12%",
      render: (_, role) => (role.type === "builtIn" ? "Built-in" : "Custom"),
    },
    {
      title: "Site scoping",
      dataIndex: "siteScoping",
      key: "siteScoping",
      width: "18%",
      render: (_, role) => siteScopingLabel(role.siteScoping),
    },
    {
      title: "Permissions",
      dataIndex: "permissionCount",
      key: "permissionCount",
      width: "12%",
      render: (_, role) => `${role.permissionCount} of ${role.permissionTotal}`,
    },
    {
      title: "Members",
      dataIndex: "members",
      key: "members",
      width: "10%",
      render: (_, role) => role.members,
    },
    {
      title: "Last modified",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: "24%",
      render: (_, role) => <span>{lastModified(role)}</span>,
    },
  ];

  return (
    <InfinityTable
      data={data}
      fetchData={() => {}}
      hasMore={false}
      tableColumns={columns}
      isLoading={false}
      onHandleRowClick={onHandleRowClick}
      heightOffset={heightOffset}
    />
  );
};

export default RolesTable;
